document.addEventListener("DOMContentLoaded", () => {
  
  // Only run on Yash Foresight products
  if (!window.isYashForesightProduct) return;
  
  // Prevent duplicate
  if (window.foresightLoaded) return;
  window.foresightLoaded = true;
  
  // Create container for falling elements
  const container = document.createElement("div");
  container.id = "seasons-foresight";
  document.body.appendChild(container);
  
  // Seasonal elements representing "Seasons of Foresight"
  const seasonalElements = [
    "🌸", // Spring petal
    "🍂", // Autumn leaf  
    "❄️", // Winter snow
    "✨", // Magic sparkle
    "⭐", // Star/glimmer
    "🍃", // Wind leaf
    "💫", // Comet
    "🌿"  // Green leaf
  ];
  
  const isMobile = window.innerWidth < 768;
  const ELEMENT_COUNT = isMobile ? 30 : 60;
  
  for (let i = 0; i < ELEMENT_COUNT; i++) {
    const element = document.createElement("div");
    element.className = "foresight-seasonal";
    
    // Random seasonal element
    const randomIndex = Math.floor(Math.random() * seasonalElements.length);
    element.textContent = seasonalElements[randomIndex];
    
    // Random starting position
    element.style.left = Math.random() * 100 + "%";
    
    // Random animation duration (slower for better visibility)
    const duration = 3 + Math.random() * 5;
    element.style.animationDuration = duration + "s";
    
    // Random delay
    element.style.animationDelay = Math.random() * 2 + "s";
    
    // Random size
    const size = isMobile
  ? 10 + Math.random() * 10
  : 16 + Math.random() * 24;
    element.style.fontSize = size + "px";
    
    // Random opacity
    element.style.opacity = 0.3 + Math.random() * 0.6;
    
    // Random rotation direction
    const rotateDirection = Math.random() > 0.5 ? 1 : -1;
    element.style.setProperty("--rotate", (Math.random() * 360 * rotateDirection) + "deg");
    
    container.appendChild(element);
  }
  
  // Remove container after 6 seconds
  setTimeout(() => {
    container.style.opacity = "0";
    setTimeout(() => {
      if (container && container.remove) {
        container.remove();
      }
    }, 1000);
  }, 8000);
});